import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classNames from 'class-names'
import without from 'lodash.without'
import {
  getRecommendation,
  saveSpecialtyIntention,
  recommendSpecialty,
  saveXkCoachBasic, getXkCoachBasic
} from '../../api/majorWishList'
import Popup from '../../components/Popup'
import Loading from '../../components/Loading'
import MajorList from '../../components/MajorList/indexNew'
import Toast from '../../components/Toast'
import OperationBtn from './OperationBtn'
import explainImg from '../../assets/img-xkCoach-explain.svg';
import headIcon from '../../assets/img-head.svg';
import explainIcon from '../../assets/icon-explain.svg';
import emptyImg from '../../assets/img-empty.svg';
import artTipsIcon from '../../assets/icon-artTips.svg';
import './Selected.less'
import {studentOrigin} from "../../constants/constants";
import {delSessionData, setSessionData} from "../../api/school";
import backIcon from "../../assets/ic_fanhui.png";
import homeIcon from "../../assets/svg/icon_Home.png";

class MajorWishList extends Component {

  static propTypes = {
    codes: PropTypes.array,
    changeCodes: PropTypes.func,
  }

  state = {
    showIntro: false,
    showWarn: false,
    majorList: [],
    classifyList: [],
    showToast: false,
    toastText: '',
    majorCount: 0,
    showConfirm: false,
    showMore:true,
    artMajorList:[],
    artMajorNameList:[],
    loading:true,
  }

  componentDidMount() {
    const { codes } = this.props
    // debugger
    this.getMajorList(codes)
  }

  componentDidUpdate(prevProps) {
    const { codes } = this.props;
    if (prevProps.codes !== codes) {
      this.getMajorList(codes)
    }
  }
  componentWillReceiveProps(n) {
    // console.log(n);
    // debugger
  }
  getMajorList(codes) {
    if (codes.length) {
      getRecommendation(codes.join(',')).then(({ data }) => {
        const classifyMap = new Map();
        let artMajorList=[];

        data.forEach(d => {
          if (classifyMap.has(d.classify.id)) {
            classifyMap.get(d.classify.id).children.push(d)
          } else {
            classifyMap.set(d.classify.id, d.classify)
            d.classify.children = [d]
          }
          if(d.isArtExam){
            artMajorList.push(d)
          }
        })
        let artMajorNameList=artMajorList.map(i=>{
          return i.name
        })
        this.setState({
          majorList: data,
          classifyList: Array.from(classifyMap.values()),
          majorCount: data.length,
          artMajorList,
          artMajorNameList,
          loading:false,
        })
      })
    } else {
      this.setState(() => {
        return {
          majorList: [],
          classifyList: [],
          majorCount: 0,
          loading:false,
        }
      })
    }
  }
  //点击查看专业详情
  handleMajorClick(major,classifyId) {
    const { history ,match} = this.props;
    let main=document.getElementsByTagName('main')[0];
    setSessionData('wish-classifyId',classifyId);
    setSessionData('wish-classifyId-position',main.scrollTop);
    history.push(`${match.url}/major/${major.id}`)
  }
  //添加其他你喜欢的专业
  handleChooseMajor() {
    const { history, match } = this.props
    history.push(`${match.url}/choose`)
  }
  //增加/删除
  handleRemoveMajor(obj, e) {
    e.stopPropagation()
    const { codes } = this.props
    const deletedCodes = obj.code
      ? [obj.code]
      : obj.children.map(d => d.code)
    const newCodes = without(codes, ...deletedCodes)
    this.props.changeCodes(newCodes, 'selected')
    this.setState(() => {
      return {
        showToast: true,
        toastText: obj.name,
      }
    })
  }
  //下一步
  handleNext() {
    const { majorList, } = this.state;
    const majorIds = majorList.map(d => d.id);
    const provinceId= JSON.parse(localStorage.getItem('provinceId'));
    const year= JSON.parse(localStorage.getItem('year'));
    delSessionData('wish-classifyId');
    delSessionData('wish-classifyId-position');
    delSessionData('choose-categoryList');
    delSessionData('choose-clickId');
    delSessionData('choose-openedId');
    delSessionData('choose-position');
    saveSpecialtyIntention(majorIds,2).then(res => {
      if(provinceId&&year){
        saveXkCoachBasic(provinceId,year,'30').then(res2=>{
          window.location.href=`${studentOrigin}/xkCoach/home`
        })
      }else {
        getXkCoachBasic().then(basic=>{
          if(basic.code==200){
            saveXkCoachBasic(basic.data.provinceId,basic.data.year,'30').then(res2=>{
              window.location.href=`${studentOrigin}/xkCoach/home`
            })
          }
        })
      }

    })
  }
  renderRightIcon(data) {
    return <OperationBtn added onClick={this.handleRemoveMajor.bind(this, data)} />
  }
  render() {
    const {
      showIntro,
      classifyList,
      showToast,
      toastText,
      showWarn,
      majorCount,
      showConfirm,
      artMajorList,
      artMajorNameList,
      loading,
    } = this.state;
    const studentSite = process.env.BUILD_TEST ? 'xs.t.shijieu.cn' : 'xs.shijieu.cn';
    if(loading){
      return  <Loading />
    }else {
      return (
          <div className="major-wish-list-wrapper xkCoach-majorwishlist">
            <header>
              <div className = "home-container">
                <div className="back" onClick={()=>{window.history.back()}}>
                  <img src={backIcon} alt=""/>
                  返回
                </div>
                <a className="home" href={`//${studentSite}`}>
                  <img src = {homeIcon} className = "home-menu" />
                  主页
                </a>
              </div>
            </header>
            <div className="bottom">
              <div className="top-banner">
                <div className='title'>
                  <h1>选择意向专业</h1>
                  <span onClick={()=>{this.setState({showIntro:true})}}><img src={explainIcon} alt=""/>如何选择</span>
                </div>
                <div className="content">为了更好的做出选科决策，请尽量把感兴趣的专业都选出来。</div>
                {artMajorList.length>0&&
                    <div className="art-tips">
                      <img src={artTipsIcon} alt=""/>
                      你选择的{artMajorNameList.slice(0,2).join('、')}等{artMajorNameList.length}个专业可能是艺考专业，考试及录取规则不同于普通高考，具体请参考相关政策。
                      <span className='guide' onClick={()=>{window.open('https://gaokao.chsi.com.cn/gkzt/ysl2023')}}>艺术类专业报考指南  ></span>
                    </div>
                }
              </div>
              {majorCount==0?
                  <div>
                    <div className="empty">
                      <div className="empty-top-text">
                        不同专业对于选考科目有不同的要求。<br/>
                        提前明确你的心仪专业，思考你可能的备选专业，可以避免在志愿填报时，无法选择理想的院校专业组。<br/>
                        接下来，请挑选出你的意向专业，我们建议你挑选出10～40个感兴趣专业。
                      </div>
                      <img className='empty-img' src={emptyImg} alt=""/>
                      <div className='empty-text'>
                        这里空空如也，快去选择你的意向专业吧！
                      </div>
                    </div>
                    <div className="btn-add" onClick={this.handleChooseMajor.bind(this)}>选择意向专业</div>
                  </div>
                  :
                  <div>
                    <MajorList
                        classifyList={classifyList}
                        onMajorClick={this.handleMajorClick.bind(this)}
                        rightIcon={this.renderRightIcon.bind(this)}
                    />
                    <div className="btn-add-other" onClick={this.handleChooseMajor.bind(this)}>选择其他意向专业</div>
                    <div className='next-step' onClick={this.handleNext.bind(this)}>完成专业选择</div>
                  </div>
              }
            </div>
            <Popup confirmText="知道了" show={showIntro} onConfirm={() => this.setState({ showIntro: false })}>
              <div className='modal-intro'>
                <img className="banner" src={explainImg} alt="banner" />
                <div className='title'>如何选择意向专业</div>
                <p>不同专业对于选考科目有不同的要求。</p>
                <p>提前思考你的备选专业，是为了避免在志愿填报时,无法选择理想的院校专业组。</p>
                <div className="block">
                  <img src={headIcon} alt=""/>
                  <div className="content">
                    <p>在专业列表中，我们根据你的测评结果，为你推荐了优先探索的专业。你也可以自主选择兴趣专业。</p>
                    <p>建议你进入专业详情，充分探索和了解后，挑选出10-40个专业。</p>
                  </div>
                </div>
              </div>
            </Popup>
            <Toast show={showToast} icon={'deleted'} onHide={() => this.setState({ showToast: false })}>
              <i>已删除</i>
              <p>{toastText}</p>
            </Toast>
          </div>
      )
    }

  }
}

export default MajorWishList



// WEBPACK FOOTER //
// ./src/pages/MajorWishListNew/Selected.js